import { IconWrapper } from '../runtime';
export default IconWrapper('flow-chart-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3.75C0 1.67893 1.67893 0 3.75 0H20.25C22.3211 0 24 1.67893 24 3.75V20.25C24 22.3211 22.3211 24 20.25 24H3.75C1.67893 24 0 22.3211 0 20.25V3.75Z",
      "fill": 'url(#' + props.id + 'bf0f32be' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M3.9485 10.2803C3.65562 9.98745 3.65563 9.51258 3.94852 9.2197L9.05294 4.11528C9.34583 3.82238 9.8207 3.82238 10.1136 4.11528L15.218 9.21969C15.5109 9.51257 15.5109 9.98742 15.218 10.2803L9.57258 15.9264L10.8398 17.1884L16.5977 17.1884L17.6796 16.1103L16.5977 15.0322L12.6562 15.0322L14.9062 12.7822L17.0625 12.7822C17.3602 12.7822 17.6457 12.9001 17.8566 13.1103L20.3341 15.579C20.6283 15.8721 20.6283 16.3485 20.3341 16.6416L17.8566 19.1103C17.6457 19.3204 17.3602 19.4384 17.0625 19.4384L10.3752 19.4384C10.0777 19.4384 9.79224 19.3205 9.5814 19.1106L6.91988 16.4602C6.62596 16.1675 6.62545 15.6918 6.91874 15.3984L12.5664 9.75008L9.58327 6.76693L6.60014 9.75005L8.51393 11.6639L6.9229 13.2549L3.9485 10.2803Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + 'bf0f32be',
      "x1": "0",
      "y1": "-9.15527e-05",
      "x2": "24",
      "y2": "23.9999",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#14BFF5"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#009AE6"
    }
  })])])]);
});